module.exports = __webpack_public_path__ + "img/version_img3.e48f9efa.png";